/**
 * Resolve a URL from a Prismic `Link` field (web / external), as used in
 * `general_website_data` and `collection` schemas (`url` + `raw.url`).
 *
 * @param {{ url?: string, raw?: { url?: string } } | null | undefined} linkField
 * @returns {string | null}
 */
function getLinkHref(linkField) {
  if (!linkField) {
    return null
  }
  const rawUrl = linkField.raw?.url
  if (typeof rawUrl === "string" && rawUrl.trim()) {
    return rawUrl.trim()
  }
  if (typeof linkField.url === "string" && linkField.url.trim()) {
    return linkField.url.trim()
  }
  return null
}

module.exports = { getLinkHref }
